module.exports = __webpack_public_path__ + "img/01.be02e269.jpg";